import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HeroUIProvider } from '@heroui/react';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import { initializeThemeFromStorage } from './hooks/useDarkMode';

initializeThemeFromStorage();

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Failed to find the root element for React mounting.');
}

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  autocapture: false,            // no clicks/forms/etc
  capture_pageview: false,       // no pageviews
  capture_dead_clicks: false,    // no "rage/dead" clicks
  disable_session_recording: true, // hard-disable replay
  property_denylist: ['$ip', '$initial_referrer', '$referrer'], 
  defaults: '2025-05-24',
});

// Optional: expose for console debugging
if (process.env.NODE_ENV !== 'production') {
  window.posthog = posthog;
}

//document.documentElement.classList.add('dark');

const root = ReactDOM.createRoot(rootElement);
root.render(
    <HeroUIProvider>
        <main className="text-foreground bg-background">
            <PostHogProvider client={posthog}>
                <App />
            </PostHogProvider>
        </main>
    </HeroUIProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
